import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { DataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector'
import { useDataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogSelector'
import { LoadingBlock } from 'modules/ai_reports/components/LoadingBlock'
import { getSlugFromTableId } from 'modules/ai_reports/lib/slug-tableid-mapping'

export type NewExporationDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const NewExplorationModal = ({ open, onOpenChange }: NewExporationDialogProps) => {
  const [localOpen, setLocalOpen] = useState(open)

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  useEffect(() => {
    setLocalOpen(open)
  }, [open, setLocalOpen])

  useEffect(() => {
    onOpenChange(localOpen)
  }, [localOpen, onOpenChange])

  const { datasources, loading, error } = useDataCatalogSelector()

  const [selectedDatasourceId, setSelectedDatasourceId] = useState<string | undefined>(undefined)

  return (
    <F0Dialog
      onClose={() => setLocalOpen(false)}
      isOpen={localOpen}
      title={i18n.t('ai_reports.reports.new_exploration')}
      primaryAction={{
        label: i18n.t('ai_reports.reports.new_exploration'),
        onClick: () => {
          selectedDatasourceId &&
            navigate(
              navigation.aiReports.catalog.slug.new.fullPath({
                slug: getSlugFromTableId(selectedDatasourceId),
              })
            )
        },
        disabled: !selectedDatasourceId,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: () => setLocalOpen(false),
      }}
    >
      <Box
        maxWidth="full"
        height="s400"
        maxHeight="full"
        flexGrow
        style={{
          height: '400px',
          flex: '1',
          display: 'flex',
        }}
      >
        {error ? (
          <>{error.message}</>
        ) : (
          <>
            {loading && <LoadingBlock />}
            {!loading && (
              <DataCatalogSelector
                datasources={datasources ?? []}
                sourceId={selectedDatasourceId}
                onSelectDatasource={setSelectedDatasourceId}
              />
            )}
          </>
        )}
      </Box>
    </F0Dialog>
  )
}
